import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      tagProfilazione: [],
      onlyTags: [],
      tagProfilazioneObj: [],
      tagsAvanzamento: [
        ["richiesta", "#00b560", "#00b560"],
        ["bozza", "#d1d1d1", "#747474"],
        ["nuovo", "#b3e5fc", "#23547b"],
        ["inviato", "#faf396", "#756b31"],
        ["letto", "#ffd8b2", "#805b36"],
        ["rifiutato", "#ffcdd2", "#8a2525"],
        ["accettato", "#c8e6c9", "#256029"],
        ["convertito", "#c5dfd7", "#256044"],
        ["non convertito", "#ffcde4", "#9c2657"],
        ["scaduto", "#ffcdd1", "#882a2a"],
      ],
      onlyTagsAvanzamento: [
        "richiesta",
        "bozza",
        "nuovo",
        "inviato",
        "letto",
        "rifiutato",
        "accettato",
        "convertito",
        "non convertito",
        "scaduto",
      ],
      tagPersonalizzati: [],
      onlyTagsPersonalizzati: [],
    };
  },
  mutations,
  actions,
  getters,
};
